// DataProtectionInformation.jsx

import { Trans, useTranslation } from 'react-i18next';

const DataProtectionInformation = ({ formData, handleChange, fontSize = '0.85em' }) => {
  const { t } = useTranslation();

  return (
    <div style={{ fontSize }}>
      {/* 🔹 Acceptació de la política de privacitat (obligatòria) */}
      <div className="web-modal-checkbox">
        <label>
          <input
            type="checkbox"
            name="acceptPrivacyPolicy"
            checked={formData.acceptPrivacyPolicy}
            onChange={handleChange}
            required
          />
          <span className="web-modal-checkbox__text">
            <Trans
              i18nKey="accept_privacy_policy"
              components={{
                a: (
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                ),
              }}
            />
          </span>
        </label>
      </div>

      {/* 🔹 Comunicacions (opcional) */}
      <div className="web-modal-checkbox">
        <label>
          <input
            type="checkbox"
            name="receiveInformation"
            checked={formData.receiveInformation}
            onChange={handleChange}
          />
          <span className="web-modal-checkbox__text">
            {t('accept_receive_info')}
          </span>
        </label>
      </div>
    </div>
  );
};

export default DataProtectionInformation;
